module.exports = __webpack_public_path__ + "static/img/图片1.c01f8cc7.png";